"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChildren = exports.getAllIncompleteChildren = exports.getActiveChildId = exports.getActiveChild = void 0;
var _reselect = require("reselect");
var _find2 = _interopRequireDefault(require("lodash/find"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getChildren = exports.getChildren = function getChildren(state) {
  return state.children;
};
var getActiveChildId = exports.getActiveChildId = function getActiveChildId(state) {
  return state.activeChild;
};
var getActiveChild = exports.getActiveChild = (0, _reselect.createSelector)(getChildren, getActiveChildId, function (children, activeChildId) {
  return (0, _find2["default"])(children, function (c) {
    return c.pawn.pawnId === activeChildId;
  });
});
var getAllIncompleteChildren = exports.getAllIncompleteChildren = (0, _reselect.createSelector)(getChildren, function (children) {
  var allChildrenProgress = [];
  children.forEach(function (child) {
    if (child.progress.completed === false) {
      allChildrenProgress.push(child);
    }
  });
  return allChildrenProgress;
});